import * as React from 'react';
import {connect} from 'react-redux';

import {colors} from 'shells/colors/colors';

import {Chevron} from '../../chevron';
import {addNewStage} from '../../ui-actions';

import styles from './stage-add-button.module.css';

type OwnProps = {
    isEmptyBoard: boolean;
};

type DispatchProps = {
    addNewStage: () => void;
};
type Props = OwnProps & DispatchProps;

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        addNewStage() {
            dispatch(addNewStage());
        },
    };
}

export class StageAddButtonComponent extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['stage-add-button']}>
                <Chevron
                    onClick={this.props.addNewStage}
                    borderColor='blue'
                    hasShadow={true}
                    hasStraightLeft={this.props.isEmptyBoard}
                    hoverStyle={{backgroundColor: colors.listSelected, cursor: 'pointer'}}
                >
                    <span
                        className={
                            this.props.isEmptyBoard
                                ? styles['button-contents-empty']
                                : styles['button-contents']
                        }
                    >
                        + Add new stage
                    </span>
                </Chevron>
                <div className={styles['right-pad']} />
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(undefined, mapDispatchToProps);
export const StageAddButton = connector(StageAddButtonComponent);
